import { render, staticRenderFns } from "./appointmenttypes.vue?vue&type=template&id=1a722fc4&scoped=true&"
import script from "./appointmenttypes.vue?vue&type=script&lang=js&"
export * from "./appointmenttypes.vue?vue&type=script&lang=js&"
import style0 from "./appointmenttypes.vue?vue&type=style&index=0&id=1a722fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a722fc4",
  null
  
)

export default component.exports